import { faCalendarWeek, faStethoscope, faUser } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Divider, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { DARK_BLUE } from "theme/colors";

import type { Patient } from "./types";

const iconStyle = { fontSize: 12, marginRight: 2 };

interface PatientInformationProps {
  patient: Patient;
}

export const PatientInformation: React.FC<PatientInformationProps> = ({ patient }) => {
  const { t } = useTranslation();

  return (
    <Stack spacing={1.5} sx={{ backgroundColor: "#fff", padding: "6px 12px" }}>
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography variant="caption2" color={DARK_BLUE[70]}>
          <FontAwesomeIcon icon={faUser} style={iconStyle} />
          {t("common.patient", { count: 1 })}:
        </Typography>
        <Typography variant="body_small">{patient.name}</Typography>
      </Stack>

      <Divider flexItem sx={{ borderColor: DARK_BLUE[30] }} />

      <Stack direction="row" spacing={1} alignItems="center">
        <Typography variant="caption2" color={DARK_BLUE[70]}>
          <FontAwesomeIcon icon={faStethoscope} style={iconStyle} />
          {t("common.treatment", { count: 1 })}:
        </Typography>
        <Typography variant="body_small">{patient.treatment}</Typography>
      </Stack>

      <Divider flexItem sx={{ borderColor: DARK_BLUE[30] }} />

      <Stack direction="row" spacing={1} alignItems="center">
        <Typography variant="caption2" color={DARK_BLUE[70]}>
          <FontAwesomeIcon icon={faCalendarWeek} style={iconStyle} />
          {t("common.week", { count: 1 })}:
        </Typography>
        <Typography variant="body_small">{patient.currentWeek}</Typography>
      </Stack>
    </Stack>
  );
};
